/**
 * Token/RFID Card error codes returned by the Asset Management API
 */
export enum TokenErrorCode {
  TOKEN_NOT_FOUND = 'TOKEN_NOT_FOUND',
  TOKEN_ALREADY_ASSIGNED = 'TOKEN_ALREADY_ASSIGNED',
  TOKEN_IS_NOT_ACTIVE = 'TOKEN_IS_NOT_ACTIVE',
}

/**
 * Determines if an error code should be displayed as a warning (less severe)
 * rather than an error.
 */
export const isWarningTokenError = (code: string): boolean => {
  return code === TokenErrorCode.TOKEN_ALREADY_ASSIGNED
}
